import { IconButton } from "@mui/material";
import {
  Ban as BlockIcon,
  Pencil as EditIcon,
  Eye as VisibilityIcon,
} from "lucide-react";
import { useHistory } from "react-router-dom";
import { Cell } from "react-table";

import { OrganisationsType } from "api/organisations/types";
import { hasPermissions } from "components/stores/UserStore";

interface Props<T extends {}> extends Cell<T> {
  handleOpenEdit: (ctx?: T) => void;
  handleOpenDelete: (ctx?: T) => void;
}

const ActionsFormatter = ({
  row,
  handleOpenEdit,
  handleOpenDelete,
}: // handleOpenEdit,
// handleOpenDelete,
Props<OrganisationsType>) => {
  const history = useHistory();
  return (
    <div>
      <IconButton
        color="primary"
        onClick={() => history.push(`/organisations/${row.original._id}`)}
      >
        <VisibilityIcon />
      </IconButton>
      {hasPermissions("update:organisations") && (
        <IconButton
          // data-testid="edit-port-button"
          color="warning"
          onClick={() => handleOpenEdit(row.original)}
        >
          <EditIcon />
        </IconButton>
      )}
      {hasPermissions("delete:organisations") && (
        <IconButton
          // data-testid="delete-port-button"
          color="error"
          // onClick={() => handleOpenDelete(row.original)}
        >
          <BlockIcon />
        </IconButton>
      )}
      {/* {hasPermissions("delete:organisations") && (
        <IconButton
          // data-testid="delete-port-button"
          color="error"
          onClick={() => handleOpenDelete(row.original)}
        >
          <DeleteIcon />
        </IconButton>
      )} */}
    </div>
  );
};

export default ActionsFormatter;
